package tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QueueStatusData(
    @SerialName("before_users") val beforeUsers: List<BeforeUser>? = null,
    @SerialName("current_user") val currentUser: CurrentUser? =null,
    @SerialName("inactive_user_count") val inactiveUserCount: Int? = null, // 1
    @SerialName("channel_name") val channelName: String? = null, // 1
    @SerialName("event_name") val eventName: String?= null // 1
)